import React, { useEffect, useState } from 'react';

export default function WarmupPlanDetails({ broadcastId, currentDay }) {
  const [warmupPlans, setWarmupPlans] = useState([]);
  const [days, setDays] = useState(0);
  const [selectedDay, setSelectedDay] = useState(currentDay || 1);
  const [loading, setLoading] = useState(false);
  const [sortDesc, setSortDesc] = useState(true);

  useEffect(() => {
    setSelectedDay(currentDay || 1);
  }, [currentDay]);

  useEffect(() => {
    const token = localStorage.getItem('prae.jwt');
    if (!broadcastId) return;
    setLoading(true);
    (async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/broadcasts/${broadcastId}/warmup-details`,
        {
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      const data = await res.json();
      setWarmupPlans(data.plan || []);
      setDays(data.days || 0);
      setLoading(false);
    })();
  }, [broadcastId]);

  if (!broadcastId || loading) return null;
  if (!warmupPlans.length || days === 0) return null;

  const dayIndex = Math.max(0, Math.min(selectedDay - 1, days - 1));
  let valuesByDomain = [];
  warmupPlans.forEach(plan => {
    const domain = plan.domain || plan.email_domain;
    const daily = Array.isArray(plan.daily_plan)
      ? plan.daily_plan
      : plan.daily_plan
        ? JSON.parse(plan.daily_plan)
        : [];
    const value = daily[dayIndex] || 0;
    if (value > 0) valuesByDomain.push({ domain, value });
  });

  valuesByDomain = valuesByDomain.sort((a, b) =>
    sortDesc ? b.value - a.value : a.value - b.value
  );

  const totalDay = valuesByDomain.reduce((a, b) => a + b.value, 0);

  return (
    <div className="mt-8 p-6 border rounded-xl bg-gray-50 shadow">
      <h3 className="text-xl font-bold mb-4 text-purple-900">
        Détail du warmup – Jour {selectedDay}
      </h3>
      <div className="flex flex-wrap gap-2 mb-6">
        {Array.from({ length: days }).map((_, i) => {
          const day = i + 1;
          const isSelected = day === selectedDay;
          const isToday = day === (currentDay || 1);
          return (
            <button
              key={day}
              onClick={() => setSelectedDay(day)}
              className={`px-3 py-1 rounded-full border transition text-sm font-semibold
                ${isSelected ? 'bg-purple-600 text-white' : 'bg-white text-gray-700'}
                ${isToday ? 'border-purple-400' : 'border-gray-300'}
              `}
              style={isSelected ? { boxShadow: '0 0 6px #a78bfa' } : {}}
            >
              Jour {day}
              {isToday && (
                <span className="ml-1 text-purple-500">(aujourd’hui)</span>
              )}
            </button>
          );
        })}
      </div>
      <table className="min-w-full text-base border bg-white rounded shadow">
        <thead>
          <tr>
            <th>Domaine</th>
            <th
              onClick={() => setSortDesc(desc => !desc)}
              style={{ cursor: 'pointer' }}
              className="select-none"
            >
              Volume
              <span className="ml-1">{sortDesc ? '▼' : '▲'}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {valuesByDomain.length === 0 ? (
            <tr>
              <td className="p-2 border text-gray-400 italic" colSpan={2}>
                Aucun envoi prévu ce jour
              </td>
            </tr>
          ) : (
            valuesByDomain.map(({ domain, value }) => (
              <tr key={domain}>
                <td className="p-2 border">{domain}</td>
                <td className="p-2 border text-center font-semibold">
                  {value}
                </td>
              </tr>
            ))
          )}
        </tbody>
        {valuesByDomain.length > 0 && (
          <tfoot>
            <tr>
              <td className="p-2 border font-bold bg-purple-50 text-right">
                Total
              </td>
              <td className="p-2 border font-bold text-center bg-purple-50">
                {totalDay}
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}
